/* @flow */
import React from 'react';
import { PropsList, PropsItem, PropsTitle, PropsValue, PropsTitleLink } from '../../ApartPage/styles';
import { navigate } from '../../ApartPage/helpers';

type TProp = {
	label: string,
	value: string,
	isBig?: boolean,
	link?: string,
	dataQa?: string,
};

type TProps = {
	data: TProp[],
};

const Props = ({ data }: TProps) => (
	<PropsList>
		{data.map(
			(item) =>
				item.value && (
					<PropsItem key={item.label}>
						{!!item.label && item.link ? (
							<PropsTitleLink id="buttonRelated" onClick={navigate(item.link)}>
								{item.label}
							</PropsTitleLink>
						) : (
							<PropsTitle>{item.label}</PropsTitle>
						)}
						<PropsValue $isBig={item.isBig} data-qa={item.dataQa}>
							{item.value}
						</PropsValue>
					</PropsItem>
				),
		)}
	</PropsList>
);

export default Props;
